// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__13DUD","FormHolder":"Login_FormHolder__3aZe2","Action":"Login_Action__uYxVh"};